/**
 * Get file content hash in SHA-256
 * @param file File
 */
export async function getFileContentHash(file: File) {
    const reader = new FileReader()
    return new Promise((resolve) => {
        reader.onload = async () => {
            const arrayBuffer = reader.result as ArrayBuffer
            const hash = await crypto.subtle.digest('SHA-256', arrayBuffer)
            const uint8ViewOfHash = new Uint8Array(hash)
            resolve(
                Array.from(uint8ViewOfHash)
                    .map((b) => b.toString(16).padStart(2, '0'))
                    .join('')
            )
        }
        reader.readAsArrayBuffer(file)
    })
}
